import React, { Fragment } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Container, Row, Col, Card, Stack, Table, Image, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Accordion, Divider, Dropdown, Icon, Label, Loader, Popup, Segment, Dimmer } from "semantic-ui-react";
import axios from 'axios'
import Swal from "sweetalert2";

const OrderDetail = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [order, setOrder] = useState(null)
    const [orderDetail, setOrderDetail] = useState(null)
    const [stateOpt, setStateOpt] = useState([])
    const [status, setStatus] = useState('')
    const [statusCode, setStatusCode] = useState(0)
    const [statusColor, setStatusColor] = useState('gray')
    const [btnChgHide, setBtnChgHide] = useState(false)
    const [dropDsb, setDropDsb] = useState(false)
    const [isLoadingType, setIsLoadingType] = useState(true)
    const [isPickUp, setIsPickUp] = useState(false)
    const [pickUpWarehouse, setPickUpWarehouse] = useState(null)
    const [hasWarehouse, setHasWarehouse] = useState(true)
    const [warehouseDetailData, setWarehouseDetailData] = useState({})
    const [warehouseDetailLoader, setWarehouseDetailLoader] = useState(true)
    const [resiData, setResiData] = useState({})
    const [resiDataLoader, setResiDataLoader] = useState(true)
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeIndices, setActiveIndices] = useState([]);
    const [activeIndicesShipping, setActiveIndicesShipping] = useState([]);
    const [totalItem, setTotalItem] = useState(0)

    const [trackingModalOpen, setTrackingModalOpen] = useState(false);
    const [trackingData, setTrackingData] = useState(null);
    const [loadingTracking, setLoadingTracking] = useState(false);

    const handleAccordionClick = (index) => {
        setActiveIndices((prevIndices) =>
            prevIndices.includes(index)
            ? prevIndices.filter((i) => i !== index) // close
            : [...prevIndices, index] // open
        );
    };

    const handleAccordionShippingClick = (index) => {
        setActiveIndicesShipping((prevIndicesShipping) =>
            prevIndicesShipping.includes(index)
            ? prevIndicesShipping.filter((i) => i !== index) // close
            : [...prevIndicesShipping, index] // open
        );
    };

    const getWarehouseDetail = async () => {
        await axios({
        method: "POST",
        // url: `${global.SRV}api_hoops/controler/cart.php/?index=22`,
        url: `${global.hoops_api}api_hoops/controler/cart.php/?index=22`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': '9c98bn59db7ejn845qwe'
        },
        })
        .then((response) => { 
            if (response.data.state == 200) {
                let data = response.data.data
                setWarehouseDetailData(data)
            }
            setWarehouseDetailLoader(false)
        })
        .catch((error) => {
            console.log(error.response.state) 
            setWarehouseDetailLoader(false)
        })
    }

    useEffect(() => {
        getWarehouseDetail()  
    }, []);

    const capitalizeWords = (str) => {
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const getStateOpt = async (statusBefore) => {
        await axios.get(`${global.SRV}api_hoops_cms/controler/order.php/?index=4`)
            .then(res => {
                if (res.data.state === 200) {
                    let data = res.data.data
                    
                    if (//statusBefore === 'CANCEL' || 
                        statusBefore === 'SETTLEMENT' || 
                        statusBefore === 'IN DELIVERY'|| 
                        statusBefore === 'ARRIVE AT DESTINATION' ||
                        statusBefore === 'RETURNED' ||
                        statusBefore === 'WAITING PAYMENT' ||
                        statusBefore === 'PAYMENT PENDING' ){

                        let newData = data.filter(o => o.execute_by !== 's')
                        setStateOpt(newData.map(o => { 
                            return {
                                key: o.id_status,
                                text: o.name.toUpperCase(),
                                value: o.name.toUpperCase(),
                                code: o.id_status,
                                color: o.color,
                            }
                        }))
                    } else {
                        let newData = data.filter(o => o.name.toLowerCase() === statusBefore.toLowerCase())
                        setStateOpt(newData.map(o => { 
                            return {
                                key: o.id_status,
                                text: o.name.toUpperCase(),
                                value: o.name.toUpperCase(),
                                code: o.id_status,
                                color: o.color,
                            }
                        }))
                        setBtnChgHide(true)
                        setDropDsb(true)
                    }
                    // if (statusBefore == "SETTLEMENT") {
                    //     let newData = data.filter(o =>
                    //         o.id_status != 3 &&
                    //         o.id_status != 5 &&
                    //         o.id_status != 4 &&
                    //         o.id_status != 9 &&
                    //         o.id_status != 10 &&
                    //         o.id_status != 11 &&
                    //         o.id_status != 12 &&
                    //         o.id_status != 13 &&
                    //         o.id_status != 14 
    
                    //     )
                    //     setStateOpt(newData.map(o => { 
                    //         return {
                    //             key: o.id_status,
                    //             text: o.name.toUpperCase(),
                    //             value: o.name.toUpperCase(),
                    //             color: o.color,
                    //         }
                    //     }))
                    // } else {
                    //     setStateOpt(data.map(o => {
                    //         return {
                    //             key: o.id_status,
                    //             text: o.name.toUpperCase(),
                    //             value: o.name.toUpperCase(),
                    //             color: o.color
                    //         }
                    //     }))
                    // }
                }
            })
    }

    const handleChangeStatus = (e, {value, options}) => { 
        setStatus(value)
        setStatusCode(options.find(o => o.value === value).code)
        setStatusColor( options.find(o => o.value === value).color)
    }

    const handleUpdateStatus = (status, idOrder) => {
        
        let arr_prod = []
        orderDetail?.order_detail.map(p => arr_prod.push({
            qty: p.qty,
            article: p.id_product,
            barcode: p.barcode,
            size: p.size,
            id_order: idOrder,
            id_warehouse: p.id_warehouse,
            status: status
        }))

        const param = {
            id_order: idOrder,
            status: status,
            products : arr_prod,
            status_code : statusCode,
            id_customer : location.state.id_customer,
            id_cart : location.state.id_cart,
        }

        //const text = statusCode === '16' ? "If you refund this transaction, the items will be removed from the cart, but stock will not be updated" : "By canceling this transaction, the items in the cart will be deleted and stock will return"
       const statusMessages = {
            '16': "If you refund this transaction, the items will be removed from the cart, but stock will not be updated",
            '2': "By canceling this transaction, the items in the cart will be deleted, and the stock will be returned",
            '8': "Are you sure you want to change the status of this order to RETURNED?",
            '7': "Are you sure you want to change the status of this order to ARRIVE AT DESTINATION?",
            '6': "Are you sure you want to change the status of this order to SETTLEMENT?",
            '1': "Are you sure you want to change the status of this order to IN DELIVERY?"
        };

        const text = statusMessages[String(statusCode)] || "Are you sure you want to change the status of this order?";
        
        Swal.fire({
            title: 'Are you sure?',
            text: text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3b5998',
            confirmButtonText: 'Yes, change it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios({
                    method: "POST",
                    url: `${global.SRV}api_hoops_cms/controler/order.php/?index=5`,
                    headers: { 'Content-Type': 'text/plain' },
                    data: param
                })
                    .then(res => { console.log(res.data)
                        if (res.data.state === 200) {
                            navigate('/order')
                        }
                    })
        
            }
        })
    }

    const getDetail = async (id_order, id_customer) => {
        let param = {
            id_order: id_order,
            id_customer: id_customer
        }

        await axios({
            method: "POST",
            url:`${global.SRV}api_hoops_cms/controler/order.php/?index=2`,
            headers: { 'Content-Type': 'text/plain' },
            data: param
        })
        .then(res => {
            if (res.data.state === 200) {
                setOrderDetail(res.data.data)
                let total = 0;
                let data = res.data.data.order_detail
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    total += parseInt(element.qty);
                }
                setTotalItem(total)
                const hasNullWarehouse = res.data.data.order_detail.some(item => item.id_warehouse === null);
                if (hasNullWarehouse) {
                    setHasWarehouse(false)
                }
                const allIndices = data.map((_, i) => i);
                setActiveIndices(allIndices);
            }
        })
    }

    const getOrderType = async (id_order) => {
        setIsLoadingType(true)
        await axios({
            method: "GET",
            url:`${global.SRV}api_hoops_cms/controler/order.php/?index=16&id_order=${id_order}`,
            headers: { 'Content-Type': 'text/plain' },
        })
        .then(res => {
            setIsLoadingType(false)
            let data = res.data
            if (data.state === 200) {
                console.log(data)
                if(data.data !== '0') {
                    setIsPickUp(true)
                    setPickUpWarehouse(data.data)
                } else {
                    setIsPickUp(false)
                }
            }
        })
        .catch((error) => {
            console.log(error)
            setIsLoadingType(false)
        })
    }

    const getResi = async (id_order) => {
        setResiDataLoader(true)
        await axios({
            method: "GET",
            url:`${global.SRV}api_hoops_cms/controler/order.php/?index=13&id_order=${id_order}`,
            headers: { 'Content-Type': 'text/plain' },
        })
        .then(res => {
            console.log(res.data.data)
            if (res.data.state === 200) {
                setResiData(res.data.data)
                console.log(res.data.data)
                const allIndices = res.data.data.map((_, i) => i);
                setActiveIndicesShipping(allIndices);
            }
            console.log(res.data.data)
            setResiDataLoader(false)
        })
    }

    const BtnGenResi = ({ order }) => {
        if (order) {
            if(!hasWarehouse) {

                if (!order.customer.no_resi && order.customer.order_state == "IN DELIVERY") {
                    return (<Button content="Generate Resi" onClick={() => getResiNumber(orderDetail)} />)
                }
    
                if (order.customer.no_resi !== null && order.customer.order_state == "IN DELIVERY") {
                    return (
                        <Fragment>
                            <label>Nomor Resi:</label>
                            <div>
                                <Label content={order.customer.no_resi} basic size="large" color="orange" icon="check"/>
                            </div>
                        </Fragment>
                    )
                }
            } else {
                if (resiData.length > 0 && order.customer.order_state === "IN DELIVERY") {
                    return (
                        <Fragment>
                            <label>{resiDataLoader && ( `Memuat Resi, Mohon Tunggu...` )}</label>
                            <label>{!resiDataLoader && ( `Nomor Resi:` )}</label>
                            <div basic color="orange" class="ui middle aligned selection list">
                                { resiData && !resiDataLoader &&
                                    Object.entries(
                                        resiData.reduce((acc, item) => {
                                        const key = item.id_warehouse;
                                        if (!acc[key]) acc[key] = [];
                                        acc[key].push(item);
                                        return acc;
                                        }, {})
                                    )
                                    .sort(([a], [b]) => {
                                        if (a === 'WH0006') return -1;
                                        if (b === 'WH0006') return 1;
                                        return a.localeCompare(b);
                                    })
                                    .map(([warehouseId, items], index) => (
                                        <div className="item row" key={warehouseId} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: '1rem' }}>
                                            <div className="col-10" style={{ display: 'flex', alignItems: 'center' }}>
                                                {/* <Label
                                                    className="ui avatar image"
                                                    content={index + 1}
                                                    basic
                                                    size="large"
                                                    color="orange"
                                                /> */}
                                                <Button
                                                    basic
                                                    color="orange"
                                                    icon
                                                >
                                                    {index + 1}
                                                </Button>
                                                <div
                                                    className="content"
                                                    style={{ marginLeft: '1rem' }}
                                                >
                                                    <div className="header">
                                                        {/* {`${capitalizeWords(warehouseDetailData[warehouseId]?.name)} (${warehouseDetailData[warehouseId]?.alias})`} */}
                                                        {`${warehouseDetailData[warehouseId]?.name} (${warehouseDetailData[warehouseId]?.alias})`}
                                                    </div>
                                                    <div>
                                                        {items.map((entry, idx) => (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            maxWidth: '300px',
                                                            }}
                                                            title={entry.no_resi}
                                                        >
                                                            {entry.no_resi}
                                                        </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-2 text-center">
                                                <Popup
                                                    content="Resi disalin!"
                                                    on="click"
                                                    position="top center"
                                                    trigger={
                                                    <Button
                                                        basic
                                                        color="orange"
                                                        icon
                                                        onClick={() =>
                                                        navigator.clipboard.writeText(items.map(entry => entry.no_resi).join(', '))
                                                        }
                                                    >
                                                        <Icon name="copy" />
                                                    </Button>
                                                    }
                                                />
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </Fragment>
                    )
                }
            }

        }
    }

    const handleClickProduct = (id) => {
        window.open(
            `https://hoopsindonesia.co.id/product/${id}`,
            '_blank' 
          );
    }

    const getResiNumber = async (order) => {
        const param =
        {
            receiver_contact: order.customer.recipient,
            receiver_name: order.customer.first_name + ' ' + order.customer.last_name,
            receiver_addr: order.customer.address_detail,
            receiver_city: order.customer.city,
            receiver_zip: order.customer.zip,
            receiver_region: order.customer.district,
            receiver_phone: order.customer.phone,
            service_code: order.customer.service_display,
            destination_code: order.customer.desti_code,
            destination_description: order.customer.city,
            weight: order.customer.total_weight,
            qty: order.customer.total_qty,
            goods_amount: order.customer.total_qty,
            delivery_price: order.customer.service_cost,
            insurance: "N",
            insurance_amount: 0,
            goods_desc: "Sport Equipment",
            order_number: order.customer.id_order,
        }

        axios({
            method: "POST",
            url: `${global.SRV}api_hoops_cms/controler/courier.php/?index=1`,
            headers: { 'Content-Type': 'text/plain' },
            data: param
        })
            .then(res => { console.log(res.data)
                if (res.data.state === 200) {
                    navigate('/order')
                }
            })
    }

    useEffect(() => {
        setOrder(location.state)
        getOrderType(location.state.id_order)
        getDetail(location.state.id_order, location.state.id_customer)
        getStateOpt(location.state.order_state)
        setStatus(location.state.order_state)
        getResi(location.state.id_order)
    }, [location.state])
    
    
    const handleTrackingClick = async (e, no_resi) => {
        e.stopPropagation();

        try {
            setLoadingTracking(true);

            const response = await axios.get(
                `${global.SRV}api_hoops_cms/controler/courier.php?index=8&no_resi=${no_resi}`
            );

            if (response.data) {
                console.log(response.data)
                setTrackingData(response.data);
                
                setTrackingModalOpen(true);
           }

        } catch (error) {
            console.error("Error fetching tracking data:", error);
        } finally {
            setLoadingTracking(false);
        }
    };

    
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)

    useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };

  }, []);
   
    return (
        isLoadingType ? (
            <Dimmer active inverted>
                <Loader>Please Wait...</Loader>
            </Dimmer>
        ) : (
        <Container fluid>
            <Modal
                show={trackingModalOpen}
                onHide={() => setTrackingModalOpen(false)}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Tracking
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{paddingRight : "35px"}}>
                    {trackingData?.data?.length > 0 ? (
                        <div className="tracking-timeline">
                            {trackingData.data.map((item, index) => (
                                
<div
    className="tracking-item"
    key={item.id}
>
    {/* Timeline indicator */}
    <div className="tracking-indicator">
        <div
            className="tracking-dot"
            style={{
                backgroundColor: item.color || "#6c757d"
            }}
        />

        {index !== trackingData.data.length - 1 && (
            <div className="tracking-line" />
        )}
    </div>

    {/* Main content */}
    <div className="tracking-main">

        {/* Information */}
        <div className="tracking-content">

            <div className="tracking-date">
                {item.delivery_datetime}
            </div>

            <div className="tracking-wrapper">
                <div
                    className="tracking-status"
                    style={
                        item?.color
                            ? {
                                backgroundColor: item.color,
                                color: "white"
                            }
                            : {}
                    }
                >
                    {item.status}
                </div>

                <div className="tracking-info">
                    {item.info}
                </div>
            </div>

            <div className="mt-2">
                <div className="tracking-info">
                    Driver Name :
                </div>

                <div
                    className="tracking-info"
                    style={{ fontWeight: "100" }}
                >
                    {item.driver_name}
                </div>
            </div>

            {item.note != "-" && (
                <div
                    style={
                        windowWidth < 992
                            ? { width: "15rem" }
                            : { width: "38rem" }
                    }
                >
                    <div
                        style={{
                            backgroundColor: "#fff3cd",
                            color: "#664d03",
                            padding: "8px 12px",
                            borderRadius: "6px",
                            border: "1px solid #ffe69c",
                            margin: "6px 0px",
                            fontSize: "0.9rem",
                            width: "100%"
                        }}
                    >
                        <p style={{ fontWeight: "600" }}>
                            Note :
                        </p>

                        {item.note}
                    </div>
                </div>
            )}
        </div>

        {/* Image */}
        {(
            (item.status === "PAPV" && item.image_delivery) ||
            (item.status === "PDO" && item.image_receipt)
        ) && (
            <div className="tracking-images">

                <div className="tracking-image-wrapper">
                    <div className="tracking-image-label">
                        {item.status === "PAPV"
                            ? "Delivery Photo"
                            : "Receipt Photo"
                        }
                    </div>

                    <img
                        src={
                            item.status === "PAPV"
                                ? item.image_delivery
                                : item.image_receipt
                        }
                        alt={
                            item.status === "PAPV"
                                ? "Delivery"
                                : "Receipt"
                        }
                        className="tracking-image"
                    />
                </div>

            </div>
        )}

    </div>
</div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center text-muted py-4">
                            No tracking history available.
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setTrackingModalOpen(false)}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0"> 
                    {!isPickUp ? 'Delivery Order Detail' : 'Pick Up Order Detail'} &nbsp;
                    <span className="fs-6 text-muted">#{location.state.id_order}</span>
                </div>
                <div className="text-muted">This is order detail that has been created by customer.</div>
            </Row>
            <Divider />
            <Row>
                <Col xl={4} lg={12} md={12}>
                    <Row className="d-flex justify-content-start mb-3 mt-3">
                        <Col xl={12} lg={12} md={12} sm={12} className="mb-3">
                            <Card style={{ borderLeft: '5px solid #3b5998' }}>
                                <Card.Body>
                                    <Card.Title>Customer</Card.Title>
                                    <Row className="mt-3 mb-3">
                                        <Col md={12}>
                                            <Stack direction="vertical" gap={2}>
                                                <Label className="fw-bold" icon="user outline" content={orderDetail && orderDetail.customer.customer_name} color="blue" />
                                                <Stack direction="horizontal" gap={1}>
                                                <Label >#{orderDetail && orderDetail.customer.id_customer}</Label>
                                                {orderDetail && (orderDetail.customer.isMember === 'Y') ? <Label content="Member" color="orange"/> : <Label content="Customer"/>}
                                                </Stack>
                                            </Stack>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={12} className="mb-3">
                                            <div className="fs-6 text-muted">Email: </div>
                                            <Stack direction="horizontal" gap={2}>
                                                <div className="fs-6 fw-bold">{orderDetail && orderDetail.customer.email}</div>
                                                <div className=""><Label color="blue" size="tiny" content={orderDetail && (orderDetail.customer.verified === '1' ? "Verified" : "Not Verified")} /></div>
                                            </Stack>
                                        </Col>
                                        <Col md={12} className="mb-3">
                                            <div className="fs-6 text-muted">Verified Date: </div>
                                            <div className="fs-6 fw-bold">{orderDetail && orderDetail.customer.verified_date}</div>
                                        </Col>
                                        <Col md={12} className="mb-3">
                                            <div className="fs-6 text-muted">Total spent since registration: </div>
                                            <div className="fs-6 fw-bold">{orderDetail && global.IDR.format(orderDetail.total_spent)}</div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        {!isPickUp ? (
                                        <Col md={12}>
                                            <div className="h5">Shipping Address: </div>
                                            <div style={{ backgroundColor: 'whitesmoke', height: 250, width: '100%', padding: 10, borderRadius: 4 }}>
                                                <div className="fw-bold">
                                                    <Label color="black" icon="point" className="mb-2" content={orderDetail && orderDetail.customer.address_label} />
                                                    <div className="text-muted">Recipient: {orderDetail && orderDetail.customer.recipient}</div>
                                                    <div>{orderDetail && orderDetail.customer.address_detail} {orderDetail && orderDetail.customer.address_detail_dua}</div>
                                                    <div>{orderDetail && orderDetail.customer.sub_district}</div>
                                                    <div>{orderDetail && orderDetail.customer.district}</div>
                                                    <div>{orderDetail && orderDetail.customer.city}</div>
                                                    <div>{orderDetail && orderDetail.customer.province}</div>
                                                    <div>{orderDetail && orderDetail.customer.zip}</div>
                                                </div>
                                            </div>
                                        </Col>
                                        ) : (
                                        <Col md={12}>
                                            <div className="h5">Warehouse Detail: </div>
                                            <div style={{ backgroundColor: 'whitesmoke', height: 250, width: '100%', padding: 10, borderRadius: 4 }}>
                                                <div className="fw-bold">
                                                    <Label color="black" icon="point" className="mb-2" content={warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.name} />
                                                    {/* <div className="text-muted">Warehouse: {warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.alias}</div> */}
                                                    <div>{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.phone}</div>
                                                    <div>{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.address}</div>
                                                    <div>{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.city}</div>
                                                    <div>{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.prov}</div>
                                                    <div>{warehouseDetailData && warehouseDetailData[pickUpWarehouse]?.zip_code}</div>
                                                </div>
                                            </div>
                                        </Col>
                                        )}
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col xl={8} lg={12} md={12}>
                    <Row className="d-flex justify-content-start mb-3 mt-3">
                        <Col xl={12} lg={12} md={12} sm={12} className="mb-3">
                            <Card style={{ borderLeft: '5px solid #3b5998' }}>
                                <Card.Body>
                                    {/* <Card.Title>Product ({orderDetail && orderDetail?.order_detail?.length})</Card.Title> */}
                                    <Card.Title>Product ({totalItem})</Card.Title>
                                    <Row className="mb-3">
                                        <Col md={12}>
                                            { !hasWarehouse  && (
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Item</th>
                                                        <th>Base Price</th>
                                                        <th>Qty</th>
                                                        {/* <th>Total</th> */}
                                                        <th>Final Price</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        orderDetail &&
                                                        orderDetail?.order_detail?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <Stack direction="horizontal" gap={2}>
                                                                        <Image src={item.image} height={60} />
                                                                        <div>
                                                                            <div className="fw-bold text-primary" style={{cursor:'pointer'}} onClick={() => handleClickProduct(item.id_product)}>{item.product_detail?.product_name}</div>
                                                                            <div className="text-muted fw-bold">{item.id_product}</div>
                                                                            <div className="text-muted fw-bold">Size: {item.size}</div>
                                                                        </div>
                                                                    </Stack>
                                                                </td>
                                                                <td className="fw-bold">{global.IDR.format(item.price)}</td>
                                                                <td className="fw-bold">
                                                                    <b className={item.qty > 1 ? "text-danger" : "text-primary"}>
                                                                        {item.qty}
                                                                    </b>
                                                                </td>
                                                                <td className="fw-bold">{global.IDR.format(item.total_price)}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </Table> )}
                                            {hasWarehouse && orderDetail && (
                                                <Accordion 
                                                    fluid 
                                                    // styled
                                                >
                                                    {Object.entries(
                                                    orderDetail.order_detail.reduce((acc, item) => {
                                                        const key = item.id_warehouse;
                                                        if (!acc[key]) acc[key] = [];
                                                        acc[key].push(item);
                                                        return acc;
                                                    }, {})
                                                    )
                                                    .sort(([a], [b]) => {
                                                        if (a === 'WH0006') return -1;
                                                        if (b === 'WH0006') return 1;
                                                        return a.localeCompare(b);
                                                    })
                                                    .map(([warehouseId, items], groupIndex) => {
                                                        const warehouseName = warehouseDetailData[warehouseId]?.name;
                                                        const warehouseAlias = warehouseDetailData[warehouseId]?.alias;
                                                        return (
                                                        // <Segment
                                                        //     key={warehouseId}
                                                        //     // raised
                                                        //     style={{
                                                        //     // borderLeft: '5px solid #f2711c',
                                                        //     // borderRadius: '10px',
                                                        //     padding: '1.5rem',
                                                        //     // boxShadow: '0 4px 10px rgba(0, 0, 0, 0.07)',
                                                        //     // backgroundColor: '#fcfcfc',
                                                        //     marginBottom: '1rem',
                                                        //     }}
                                                        // >
                                                        <>
                                                            <Accordion.Title
                                                                active={activeIndices.includes(groupIndex)}
                                                                index={groupIndex}
                                                                onClick={() => handleAccordionClick(groupIndex)}
                                                                // className="fw-bold text-dark"
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '1.2rem',
                                                                    paddingBottom: '0.5rem',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                            <Icon name={activeIndices.includes(groupIndex) ? 'angle down' : 'angle right'} color="orange" />
                                                            {warehouseDetailLoader ? (
                                                                <span className="text-secondary">
                                                                    <Loader active inline size="tiny" /> Loading...
                                                                </span>
                                                            ) : (
                                                                <>
                                                                <span style={{ marginLeft: '0.5rem' }}>
                                                                    <h5>
                                                                    {/* Warehouse: <span className="text-orange">{warehouseName ? capitalizeWords(warehouseName) : '-'}</span> ({warehouseAlias ?? '-'}) */}
                                                                    Warehouse: <span className="text-orange">{warehouseName ?? '-'}</span> ({warehouseAlias ?? '-'})
                                                                    </h5>
                                                                </span>
                                                                </>
                                                            )}
                                                            </Accordion.Title>

                                                            <Accordion.Content active={activeIndices.includes(groupIndex)}>
                                                            <Table celled striped>
                                                                <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Item</th>
                                                                    <th>Base Price</th>
                                                                    <th>Qty</th>
                                                                    {/* <th>Total</th> */}
                                                                    <th>Final Price</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {items.map((item, index) => (
                                                                    <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                        <Image src={item.image} height={60} bordered rounded />
                                                                        <div>
                                                                            <div
                                                                            className="fw-bold text-primary"
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleClickProduct(item.id_product)}
                                                                            >
                                                                            {item.product_detail?.product_name}
                                                                            </div>
                                                                            <div className="text-muted fw-bold">{item.id_product}</div>
                                                                            <div className="text-muted fw-bold">Size: {item.size}</div>
                                                                        </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className="fw-bold">{global.IDR.format(item.price)}</td>
                                                                    <td className="fw-bold">
                                                                        <b className={item.qty > 1 ? "text-danger" : "text-primary"}>
                                                                            {item.qty}
                                                                        </b>
                                                                    </td>
                                                                    <td className="fw-bold">{global.IDR.format(item.total_price)}</td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            </Table>
                                                            </Accordion.Content>
                                                        </>
                                                        // </Segment>
                                                        );
                                                    })}
                                                </Accordion>
                                            )}
                                            <Row className="d-flex justify-content-center">
                                                <Col md={12} >
                                                    <div style={{ backgroundColor: 'whitesmoke', height: 90, padding: 10, borderRadius: 4 }}>
                                                        <Row className="d-flex align-items-middle fw-bold">
                                                            <Col>
                                                                <div className="text-center">
                                                                    <div className="text-muted">Product</div>
                                                                    <div>{orderDetail && global.IDR.format(orderDetail.customer.total_price)}</div>
                                                                </div>
                                                            </Col>
                                                            <Col>
                                                                <div className="text-center">
                                                                    <div className="text-muted">Voucher</div>
                                                                    <div>{global.IDR.format(orderDetail && orderDetail.customer.total_voucher)}</div>
                                                                </div>
                                                            </Col>
                                                            {!isPickUp ?
                                                            <>
                                                                <Col>
                                                                    <div className="text-center">
                                                                        <div className="text-muted">Shipping</div>
                                                                        <div>{orderDetail && global.IDR.format(orderDetail.customer.service_cost)}</div>
                                                                        {orderDetail && orderDetail.customer.shipping_voucher > 0 ? <div style={{color:'coral'}}><Icon name="shipping fast"/> Voucher {orderDetail && orderDetail.customer.shipping_voucher}</div> : <></>}
                                                                    </div>
                                                                </Col>
                                                                <Col>
                                                                    <div className="text-center">
                                                                        <div className="text-muted">Shipping Insurance</div>
                                                                        <div>{global.IDR.format(orderDetail && orderDetail.customer.asuransi)}</div>
                                                                    </div>
                                                                </Col>
                                                                </> : <></>
                                                                }
                                                                <Col>
                                                                    <div className="text-center">
                                                                        <div className="text-muted">Total Order</div>
                                                                        <div><Label content={orderDetail && global.IDR.format(orderDetail.customer.total_payment)} color="orange"/></div>
                                                                    </div>
                                                                </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        {!isPickUp ?
                        <>
                        <Col xl={12} lg={12} md={12} sm={12} className="mb-3 mt-3">
                            <Card style={{ borderLeft: '5px solid #3b5998' }}>
                                <Card.Body>
                                    <Card.Title className="mb-3">Shipping Detail</Card.Title>
                                    {resiDataLoader && ( <label>Memuat Detail, Mohon Tunggu...</label>)}
                                    {hasWarehouse && resiData && !resiDataLoader && (
                                        <Accordion fluid>
                                            {Object.entries(
                                                resiData.reduce((acc, item) => {
                                                    const key = item.id_warehouse;
                                                    if (!acc[key]) acc[key] = [];
                                                    acc[key].push(item);
                                                    return acc;
                                                }, {})
                                            )
                                            .sort(([a], [b]) => {
                                                if (a === 'WH0006') return -1;
                                                if (b === 'WH0006') return 1;
                                                return a.localeCompare(b);
                                            })
                                            .map(([warehouseId, items], groupIndex) => {
                                                const item = items[0]; // use the first item in the group

                                                return (
                                                    <React.Fragment key={warehouseId}>
                                                        {/*
                                                        <Accordion.Title
                                                            active={activeIndicesShipping.includes(groupIndex)}
                                                            index={groupIndex}
                                                            onClick={() => handleAccordionShippingClick(groupIndex)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                fontSize: '1.2rem',
                                                                paddingBottom: '0.5rem',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <Icon name={activeIndicesShipping.includes(groupIndex) ? 'angle down' : 'angle right'} color="orange" />
                                                            <div style={{ marginLeft: '0.5rem' }}>
                                                                <h5 className="fw-bold text-secondary">
                                                                    // Warehouse: {capitalizeWords(warehouseDetailData[warehouseId]?.name)} ({warehouseDetailData[warehouseId]?.alias})
                                                                    Warehouse: {warehouseDetailData[warehouseId]?.name} ({warehouseDetailData[warehouseId]?.alias})
                                                                </h5>
                                                            </div>
                                                        </Accordion.Title>
                                                        */}
                                                        <Accordion.Title
                                                            active={activeIndicesShipping.includes(groupIndex)}
                                                            index={groupIndex}
                                                            onClick={() => handleAccordionShippingClick(groupIndex)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                fontSize: '1.2rem',
                                                                paddingBottom: '0.5rem',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                width: '100%',
                                                            }}
                                                        >
                                                            {/* LEFT */}
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <Icon
                                                                    name={
                                                                        activeIndicesShipping.includes(groupIndex)
                                                                            ? 'angle down'
                                                                            : 'angle right'
                                                                    }
                                                                    color="orange"
                                                                />

                                                                <div style={{ marginLeft: '0.5rem' }}>
                                                                    <h5 className="fw-bold text-secondary mb-0">
                                                                        Warehouse: {warehouseDetailData[warehouseId]?.name} (
                                                                        {warehouseDetailData[warehouseId]?.alias})
                                                                    </h5>
                                                                </div>
                                                            </div>

                                                            {/* RIGHT */}
                                                            {item?.id_courier == 3 && (
                                                                <Button
                                                                    color="orange"
                                                                    size="small"
                                                                    loading={loadingTracking}
                                                                    disabled={loadingTracking}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        console.log(item)
                                                                        // action tombol
                                                                        handleTrackingClick(e, item?.no_resi)
                                                                    }}
                                                                    style={{ padding: "0.6rem" }}
                                                                >
                                                                    <Icon className="ms-1 me-1" name="truck" />
                                                                    <span className="me-1">Tracking</span>
                                                                </Button>
                                                            )}
                                                        </Accordion.Title>

                                                        <Accordion.Content active={activeIndicesShipping.includes(groupIndex)}>
                                                            <Row className="my-2">
                                                                <Col md={3}>
                                                                    <Stack direction="horizontal" gap={2}>
                                                                        <div style={{ border: 'solid 1px lightgrey', borderRadius: 5, padding: 5 }}>
                                                                            <Image src={item?.logo} height={36} width={36} />
                                                                        </div>
                                                                        <div>
                                                                            <div className="fw-bold">{item?.courier_name}</div>
                                                                            <div className="text-muted">{item?.description}</div>
                                                                        </div>
                                                                    </Stack>
                                                                </Col>
                                                                <Col className="fw-bold text-center">
                                                                    <div className="text-muted">Service Type</div>
                                                                    <div>{item?.service_display}</div>
                                                                </Col>
                                                                <Col className="fw-bold text-center">
                                                                    <div className="text-muted">Weight</div>
                                                                    <div>{item?.weight} kg</div>
                                                                </Col>
                                                                <Col className="fw-bold text-center">
                                                                    <div className="text-muted">Shipping Cost</div>
                                                                    <div>{global.IDR.format(item.shipping_cost)}</div>
                                                                </Col>
                                                                <Col className="fw-bold text-center">
                                                                    <div className="text-muted">Insurance</div>
                                                                    <div>{global.IDR.format(item.shipping_insurance)}</div>
                                                                </Col>
                                                            </Row>
                                                        </Accordion.Content>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </Accordion>
                                    )}
                                    {hasWarehouse && !resiDataLoader && (
                                    <Row className="d-flex justify-content-center">
                                        <Col md={12} >
                                            <div style={{ backgroundColor: 'whitesmoke', height: 90, padding: 10, borderRadius: 4 }}>
                                                <Row className="d-flex align-items-middle fw-bold">
                                                    <Col md={3}>
                                                        &nbsp;
                                                    </Col>
                                                    <Col>
                                                        &nbsp;
                                                    </Col>
                                                    <Col>
                                                        &nbsp;
                                                    </Col>
                                                    <Col>
                                                        <div className="text-center">
                                                            <div className="text-muted">Total Shipping</div>
                                                            <div>{orderDetail && global.IDR.format(orderDetail.customer.service_cost)}</div>
                                                            {orderDetail && orderDetail.customer.shipping_voucher > 0 ? <div style={{color:'coral'}}><Icon name="shipping fast"/> Voucher {orderDetail && orderDetail.customer.shipping_voucher}</div> : <></>}
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="text-center">
                                                            <div className="text-muted">Total Insurance</div>
                                                            <div>{global.IDR.format(orderDetail && orderDetail.customer.asuransi)}</div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    )}
                                    {!hasWarehouse && (
                                    <Row className="mb-2">
                                        <Col md={4}>
                                            <Stack direction="horizontal" gap={2}>
                                                <div>
                                                    <div style={{border:'solid 1px lightgrey',borderRadius:5, padding:5}}>
                                                        <Image src={orderDetail && orderDetail.customer.courier_logo} height={36} width={36} />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{orderDetail && orderDetail.customer.courier_name}</div>
                                                    <div className="text-muted">{orderDetail && orderDetail.customer.courier_description}</div>
                                                </div>
                                            </Stack>
                                        </Col>
                                        <Col className="fw-bold text-center">
                                            <div className="text-muted">Service Type</div>
                                            {/* <div>{orderDetail && orderDetail.customer.service_display}</div> */}
                                            <div>{orderDetail && orderDetail.customer.id_service}</div>
                                        </Col>
                                        <Col className="fw-bold text-center">
                                            <div className="text-muted">Weight</div>
                                            <div>{orderDetail && orderDetail.customer.total_weight} kg</div>
                                        </Col>
                                        <Col className="fw-bold text-center">
                                            <div className="text-muted">Shipping Cost</div>
                                            <div>{orderDetail && global.IDR.format(orderDetail.customer.service_cost)}</div>
                                        </Col>
                                    </Row>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                        </> : <></>
                        }
                        <Col xl={12} lg={12} md={12} sm={12} className="mb-3 mt-3">
                            <Card style={{ borderLeft: '5px solid #3b5998' }}>
                                <Card.Body>
                                    <Card.Title className="mb-4 fw-bold">Status</Card.Title>
                                    <Card.Subtitle className="mb-3 fw-bold">Current Status : {(location.state.order_state)}</Card.Subtitle>
                                    <Card.Subtitle className="fw-bold">Edit Status :</Card.Subtitle>
                                    <Row className="mt-3">
                                        <Col md={12} className="mb-3">
                                            {/*
                                            <Dropdown
                                                className="me-3"
                                                disabled={dropDsb}
                                                button
                                                value={status}
                                                // options={stateOpt}
                                                options={
                                                    isPickUp
                                                    ? stateOpt.filter(opt => opt.value !== 'IN DELIVERY')
                                                    : stateOpt.filter(opt => opt.value !== 'PICK UP COMPLETED')
                                                }
                                                onChange={handleChangeStatus}
                                                style={{ color: statusColor  }}
                                            />
                                            */}
                                            <Dropdown
                                                className="me-3"
                                                disabled={dropDsb}
                                                button
                                                value={status}
                                                options={
                                                    (
                                                        isPickUp
                                                            ? stateOpt.filter(opt => opt.value !== "IN DELIVERY")
                                                            : stateOpt.filter(opt => opt.value !== "PICK UP COMPLETED")
                                                    ).map(opt => ({
                                                        ...opt,
                                                        disabled: location.state.order_state === "SETTLEMENT" && opt.value === "CANCEL"
                                                    }))
                                                }
                                                onChange={handleChangeStatus}
                                                style={{ color: statusColor }}
                                            />
                                            <span className="text-muted me-3">{orderDetail && orderDetail.customer.date_update}</span>
                                            <Button color="facebook" icon="exchange" labelPosition="right" content="Change" disabled={(location.state.order_state === "SETTLEMENT" && status === "CANCEL") || (location.state.order_state === status)} hidden={btnChgHide} onClick={() => status != '' ? handleUpdateStatus(status, location.state.id_order) : alert("Status not selected")}/>
                                        </Col>
                                        <Col md={12}><BtnGenResi order={orderDetail} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>

        </Container>
        )
    )
}

export default OrderDetail